import Loadable from 'react-loadable';

export const FourOhFourPage = Loadable<any, any>({
  loader: () => import(/* webpackChunkName: "FourOhFourPage" */ './FourOhFourPage'),
  loading: () => null,
});
